<template>
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M20 12H4M4 12L10 18M4 12L10 6"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>
